import type { ReactNode } from "react";
import MicroLabel from "@/components/base/MicroLabel";
import type { MicroMark } from "@/components/base/MicroLabel";

type Tone = "plain" | "accent" | "primary";

const BORDER: Record<Tone, string> = {
  plain: "border-foreground-950",
  accent: "border-accent-500",
  primary: "border-primary-500",
};

const BODY: Record<Tone, string> = {
  plain: "text-foreground-600",
  accent: "text-accent-900",
  primary: "text-foreground-700",
};

const LABEL: Record<Tone, "default" | "accent" | "primary"> = {
  plain: "default",
  accent: "accent",
  primary: "primary",
};

interface InlineNoteProps {
  label: string;
  mark: MicroMark;
  tone?: Tone;
  className?: string;
  children: ReactNode;
}

/**
 * Top-border strip note used inside cards and panels. Callers own the
 * padding/background; the border weight, marker and label style are fixed.
 */
export default function InlineNote({
  label,
  mark,
  tone = "plain",
  className = "",
  children,
}: InlineNoteProps) {
  return (
    <div className={`border-t-2 ${BORDER[tone]} ${className}`}>
      <MicroLabel mark={mark} tone={LABEL[tone]}>
        {label}
      </MicroLabel>
      <p className={`mt-2 text-xs md:text-sm leading-relaxed ${BODY[tone]}`}>{children}</p>
    </div>
  );
}